export default function CookieBotScript({ cookieBotId }: { cookieBotId: string }) {
  return (
    <script
      id="CookieBot"
      src="https://consent.cookiebot.com/uc.js"
      data-cbid={cookieBotId}
      data-blockingmode="auto"
    />
  )
}
